export { LeftAdornment } from './LeftAdornment'
